
export const ArrowIcon: React.FC<React.SVGProps<SVGSVGElement>> = props => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="34" height="21" viewBox="0 0 34 21" {...props}>
      <path
        d="M31.05,0H3A2.93,2.93,0,0,0,.79,4.92l14,15.14a3,3,0,0,0,4.34,0l14-15.14A2.93,2.93,0,0,0,31.05,0Z"
      />
    </svg>
  );
};
